import React from 'react';
import * as Icons from 'lucide-react';
import { problems, stats } from '../mock';

const ProblemsSection = () => {
  return (
    <section className="relative py-24 lg:py-36 bg-paper overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Heading */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-divider"></span>
              <span className="font-mono-label text-gold-dark">The Reality</span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl leading-[1.08] text-ink">
              70% of business owners are never able to <span className="italic text-gold-dark">bullet-proof</span> their company.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="font-sans-body text-lg text-muted-kmh leading-relaxed">
              They miss compliance and end up paying the cost of penalties, legal troubles, and operational disruptions.
              Here are the five fault-lines we close — permanently.
            </p>
          </div>
        </div>

        {/* Problems grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 border-t border-line">
          {problems.map((p, idx) => {
            const I = Icons[p.icon] || Icons.AlertCircle;
            return (
              <div
                key={p.title}
                className={`group relative py-10 px-6 border-b border-line ${
                  idx !== problems.length - 1 ? 'lg:border-r' : ''
                } card-lift bg-paper hover:bg-ivory`}
              >
                <span className="font-mono-label text-gold absolute top-6 right-6">0{idx + 1}</span>
                <I className="w-9 h-9 text-ink group-hover:text-gold-dark" strokeWidth={1.2} />
                <h3 className="font-serif-display text-2xl text-ink mt-7">{p.title}</h3>
                <p className="font-sans-body text-sm text-muted-kmh leading-relaxed mt-3">{p.description}</p>
              </div>
            );
          })}
        </div>

        {/* Stats strip */}
        <div className="mt-24 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((s, idx) => (
            <div key={idx} className="border-l-2 border-gold pl-6">
              <p className="font-serif-display text-4xl lg:text-5xl text-ink">{s.value}</p>
              <p className="font-sans-body text-sm text-muted-kmh leading-relaxed mt-3 max-w-[16rem]">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemsSection;
